/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MercerStandingJobCode } from './mercer-standing-job-code';

export interface MercerStandingEmployeeDetails {
  id?: string;
  employeeId?: string;
  positionClass?: number | null;
  originalProposedPositionClass?: number | null;
  positionClassDeviationReason?: string | null;
  jobCodeId?: string | null;
  state?: MercerStandingEmployeeDetailsStateEnum;
  approvedAt?: string | null;
  startedAt?: string | null;
  jobCode?: MercerStandingJobCode;
  isGermanPartialEvaluation?: boolean;
  orgLevel?: number | null;
  orgSize?: number | null;
  positionClassValidFrom?: string | null;
  jobCodeValidFrom?: string | null;
  isHrEditDisabled?: boolean;
  /**
   * True when the employee security settings mark the position evaluation as read only for the requester\'s role. The evaluation stays visible in the list, but its edit entry point must be locked.
   */
  isCpeReadonly?: boolean;
  isPromotionAllowed?: boolean;
  wasPromoted?: boolean;
  showWasPromoted?: boolean;
}
export enum MercerStandingEmployeeDetailsStateEnum {
  Open = 'Open',
  RequestedHr = 'RequestedHR',
  RequestedCb = 'RequestedCB',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Review = 'Review'
}
